const stateKeys = {
  isAccessToken: 'isAccessToken'
}

const initialState = () => ({
  isAccessToken: false
})

export const state = () => initialState()

export const mutations = {
  setIsAccessToken(state, value) {
    state.isAccessToken = value
  }
}

export const actions = {
  getIsAccessToken() {
    return this.$storage.getUniversal(stateKeys.isAccessToken)
  },
  setIsAccessToken(_, value) {
    this.$storage.setUniversal(stateKeys.isAccessToken, value)
  }
}
